import { render, staticRenderFns } from "./finance-definitions.vue?vue&type=template&id=795f518c"
import script from "./finance-definitions.vue?vue&type=script&lang=js"
export * from "./finance-definitions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports